import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Snippet } from '../../services/models/Snippet.model'

interface SnippetsState {
    snippets: Snippet[]
    loading: boolean
    error: string | null
}

const initialState: SnippetsState = {
    snippets: [],
    loading: false,
    error: null
}

const snippetsSlice = createSlice({
    name: 'snippets',
    initialState,
    reducers: {
        addSnippet: (state, action: PayloadAction<Snippet>) => {
            state.snippets.push(action.payload)
        },
        updateSnippet: (state, action: PayloadAction<Partial<Snippet>>) => {
            const index = state.snippets.findIndex((s) => s.id === action.payload.id)
            if (index !== -1) {
                state.snippets[index] = { ...state.snippets[index], ...action.payload }
            }
        },
        deleteSnippet: (state, action: PayloadAction<string>) => {
            state.snippets = state.snippets.filter((s) => s.id !== action.payload)
        },
        setSnippets: (state, action: PayloadAction<Snippet[]>) => {
            state.snippets = action.payload
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        }
    }
})

export const { addSnippet, updateSnippet, deleteSnippet, setSnippets, setLoading, setError } = snippetsSlice.actions
export default snippetsSlice.reducer
